<template>
  <div v-show="isVisible">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      required: true,
      type: Boolean,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/report-a-problem/_vue/StepPanel.vue